import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ActualiteService {
    private readonly width: number = 768;
    private readonly height: number = 480;

    constructor() {}

    public getWidth(): number {
        return this.width;
    }

    public getHeight(): number {
        return this.height;
    }
}
